import * as angular from 'angular';

import { ComponentDefinition } from '../../../../models';

class DigitalStatesErrorsController implements angular.IComponentController {

    readonly formController: angular.IFormController;
    readonly selectedSet; // Type to be determined
    
    static $inject = [];
}

export const wtDigitalStatesErrors: ComponentDefinition = {
    componentId: 'wtDigitalStatesErrors',
    controller: DigitalStatesErrorsController,
    template: require('./digitalStatesErrors.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '<',
        selectedSet: '<'
    }
};
